// CustomerWizard.jsx
import React from "react";
import {
    Box,
    Paper,
    Stepper,
    Step,
    StepLabel,
    Button,
    Grid,
    TextField,
    MenuItem,
    Typography,
    Divider,
} from "@mui/material";
import { useForm, Controller, FormProvider } from "react-hook-form";
import Step1 from "./Steps/Step1";
import Step2 from "./Steps/Step2";
import Step3 from "./Steps/Step3";
import Step4 from "./Steps/Step4";
import CustomStepsHeader from "./CustomStepsHeader";

const steps = ["Stammdaten", "Standorte", "Maschinen", "User"];

const defaultValues = {
    step_one: {
        customerName: "",
        status: "aktiviert",
        invoice: {
            company: "",
            addressLine2: "",
            street: "",
            country: "Deutschland",
            zip: "",
            city: "",
            email: "",
            extraInfo: "",
        },
    },
    step_two: { locations: [] },
    step_three: { machines: [] },
    step_four: { users: [] }
};

export default function KundenStepper() {
    const [activeStep, setActiveStep] = React.useState(0); // 0 for step1 , ...

    const methods = useForm({
        mode: "onChange",
        defaultValues,
    });

    const { control, handleSubmit, formState, watch, trigger } = methods;
    const { isValid } = formState;

    const onSubmit = (data) => {
        if (activeStep < steps.length - 1) {
            setActiveStep((s) => s + 1);
        } else {
            // final submit – replace with API call
            console.log("SUBMIT:", data);
            alert("Submitted! Check console for payload.");
        }
    };

    const handleBack = () => setActiveStep((s) => s - 1);

    // Require only key fields on step 1
    // only for step 1
    const step1Required = [
        "step_one.customerName",
        "step_one.status",
        "step_one.invoice.company",
        "step_one.invoice.street",
        "step_one.invoice.country",
        "step_one.invoice.zip",
        "step_one.invoice.city",
        "step_one.invoice.email",
    ];

    const next = async () => {
        if (activeStep === 0) {
            const ok = await trigger(step1Required);
            if (!ok) return;
        }
        handleSubmit(onSubmit)();
    };

    const handleStepClick = (e) => {
        const stepIndex = steps.indexOf(e.currentTarget.textContent);
        if (stepIndex >= 0 && stepIndex < activeStep) {
            setActiveStep(stepIndex);
        }
    };

    return (
        <div className="kunden_stepper">

            <FormProvider {...methods}>
                <Box sx={{ pb: 3 }}>
                    <Box sx={{ mb: 4 }}>
                        <CustomStepsHeader activeStep={activeStep} handleStepClick={handleStepClick}/>
                    </Box>

                    {activeStep === 0 && (
                        <Step1 control={control} watch={watch} isValid={isValid} />
                    )}
                    {activeStep === 1 && <Step2 />}
                    {activeStep === 2 && <Step3 />}
                    {activeStep === 3 && <Step4 />}

                    <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                        <Button
                            variant="outlined"
                            disabled={activeStep === 0}
                            onClick={handleBack}
                        >
                            ZURÜCK
                        </Button>
                        <Button
                            variant="contained"
                            onClick={next}
                            disabled={activeStep === 0 ? false : false}
                        >
                            {activeStep === steps.length - 1 ? "ABSCHLIESSEN" : "NÄCHSTER SCHRITT"}
                        </Button>
                    </Box>
                </Box>
            </FormProvider>
        </div>
    );
}